import {
  addLUTData,
  AssetImporter,
  AssetManagerPlugin,
  CameraViewPlugin,
  GroundPlugin,
  ViewerApp,
} from "webgi";

const loadHandModel = async (viewer: ViewerApp, handSize: string) => {
  const groundPlugin = viewer.getPlugin(GroundPlugin)!;
  const assetManager = viewer.getPlugin(AssetManagerPlugin)!;

  if (handSize && (handSize === "short" || handSize === "long")) {
    let isExisiting = false;
    let promises: Promise<any>[] = [];
    let fn = async (m: any) => {
      if (m.name === "hand") {
        m.visible = true;
        isExisiting = true;
        if (groundPlugin) {
          groundPlugin.enabled = false;
        }
      }
    };
    viewer.scene.modelRoot.traverse((m) => promises.push(fn(m)));
    await Promise.all(promises);
    if (!isExisiting) {
      if (handSize === "short") {
        await assetManager.addFromPath("./assets/models/short_hand.glb", {
          autoScale: false,
          autoScaleRadius: 1,
          pseudoCenter: false,
        });
      }
      if (handSize === "long") {
        await assetManager.addFromPath("./assets/models/long_hand.glb", {
          autoScale: false,
          autoScaleRadius: 1,
          pseudoCenter: false,
        });
      }
    }

    // Turn off lut for the hand
    let promisesLUT: Promise<any>[] = [];
    let fnLUT = async (m: any) => {
      if (m.userData.name === "hand") {
        m.children.map(async (m_child: any) => {
          const itemMaterial = m_child.material;
          addLUTData(itemMaterial);
          // @ts-ignore
          itemMaterial?.materialObject?.userData["LUTPlugin1"].enable = false;
          m_child.setMaterial(itemMaterial);
        });
      }
    };
    viewer.scene.modelRoot.traverse((m) => promisesLUT.push(fnLUT(m)));
    await Promise.all(promisesLUT);
  }
};

export default loadHandModel;
